import {
  ArrowBackOutlined,
  RefreshOutlined
} from "@material-ui/icons";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useConfirm from "../../../../hooks/useConfirm";
import useCrudApi from "../../../../hooks/useCrudApi";
import { useQuery } from "../../../../hooks/useQuery";
import useToast from "../../../../hooks/useToast";
import { AssociationService_adm } from "../../../../service/admin_service/AssociationService_adm";
import { AssociationService } from "../../../../service/AssociationService";

const AssociationMembersList = ({
  selection = false,
  id_type,
  handleSelectedCV,
}) => {
  const [membres, setMembres] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const navigate = useNavigate();
  const { Toast, showToast } = useToast();
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const query = useQuery();
  const uuid = query.get("ref");
  const associationAPI = useCrudApi(AssociationService_adm);

  const showMembreDetails = (id) => {
    navigate(`details?ref=${id}`);
  };

  const handleFetchMembre = () => {
    setDataLoading(true);
    AssociationService.showMembres(uuid)
      .then((res) => {
        if (res && res.data) {
          setMembres(res.data);
          setFilteredRows(res.data);
        } else {
          setMembres([]);
          setFilteredRows([]);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleUseCV = (id_type, identite) => {
    handleSelectedCV(id_type, identite);
  };

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(membres);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      membres.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot),
          ),
        ),
      ),
    );
  };

  const table_colonne = [
    {
      field: "membre_nom",
      headerName: "Nom",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "membre_prenoms",
      headerName: "Prénoms",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "annee_naissance",
      headerName: "Année de naissance",
      flex: 1,
      minWidth: 150,
    },
    {
      // field: "created_at",
      field: "role_responsable",
      headerName: "Fonction",
      minWidth: 150,
    },
    {
      // field: "created_at",
      field: "email2",
      headerName: "Email",
      minWidth: 150,
    },
    {
      // field: "created_at",
      field: "telephone1",
      headerName: "Telephone",
      minWidth: 150,
    },
   /*  {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Afficher details"
              color="primary"
              onClick={(e) => showMembreDetails(params.row.id_ext_association)}
            >
              <RemoveRedEyeOutlined />
            </IconButton>
            {selection && (
              <Button
                sx={{ ml: 0.5 }}
                disabled={params.row.id_type > 0}
                title="Utiliser ce cv"
                color="primary"
                variant="contained"
                size="small"
                onClick={(e) => handleUseCV(id_type, params.row)}
              >
                Utiliser
              </Button>
            )}
          </Grid>
        );
      },
    }, */
  ];

  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (uuid) {
      associationAPI.findOne(uuid);
    }
  }, [uuid]);

  useEffect(() => {
    handleFetchMembre();
  }, []);

  return (
    <>
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title={"Liste membre"}
              titleTypographyProps={{ variant: "h5" }}
              avatar={
                <IconButton color="primary" onClick={handleGoBack}>
                  <ArrowBackOutlined />
                </IconButton>
              }
              action={
                <Grid container spacing={1}>
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      onChange={(e) => handleFilter(e.target.value)}
                      placeholder="Recherche"
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton color="primary" onClick={handleFetchMembre}>
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                </Grid>
              }
            />
            {/* <Grid container spacing={2} mb={2}>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Paper sx={{ height: 100 }}>
                  <Grid>
                    <Typography>Moyenne</Typography>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Paper sx={{ height: 100 }}>Moyenne</Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Paper sx={{ height: 100 }}>Moyenne</Paper>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Paper sx={{ height: 100 }}>Moyenne</Paper>
              </Grid>
            </Grid> */}
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                rows={filteredRows}
                getRowId={(row) => row.uuid_user}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default AssociationMembersList;
